export type CommunityColorKey = 'pcos' | 'diabetes' | 'mental' | 'thyroid' | 'skin' | 'general';

export interface CommunityColorTheme {
  key: CommunityColorKey;
  name: string;
  hue: number;
  color: string;
  dark: string;
  light: string;
  muted: string;
  shadow: string;
  gradient: string;
}

export const COMMUNITY_COLORS: Record<CommunityColorKey, CommunityColorTheme> = {
  pcos: {
    key: 'pcos',
    name: 'PCOS',
    hue: 170,
    color: 'var(--community-pcos-color)',
    dark: 'var(--community-pcos-dark)',
    light: 'var(--community-pcos-light)',
    muted: 'var(--community-pcos-muted)',
    shadow: 'var(--community-pcos-shadow)',
    gradient: 'var(--community-pcos-gradient)',
  },
  diabetes: {
    key: 'diabetes',
    name: 'Diabetes',
    hue: 215,
    color: 'var(--community-diabetes-color)',
    dark: 'var(--community-diabetes-dark)',
    light: 'var(--community-diabetes-light)',
    muted: 'var(--community-diabetes-muted)',
    shadow: 'var(--community-diabetes-shadow)',
    gradient: 'var(--community-diabetes-gradient)',
  },
  mental: {
    key: 'mental',
    name: 'Mental Health',
    hue: 265,
    color: 'var(--community-mental-color)',
    dark: 'var(--community-mental-dark)',
    light: 'var(--community-mental-light)',
    muted: 'var(--community-mental-muted)',
    shadow: 'var(--community-mental-shadow)',
    gradient: 'var(--community-mental-gradient)',
  },
  thyroid: {
    key: 'thyroid',
    name: 'Thyroid',
    hue: 15,
    color: 'var(--community-thyroid-color)',
    dark: 'var(--community-thyroid-dark)',
    light: 'var(--community-thyroid-light)',
    muted: 'var(--community-thyroid-muted)',
    shadow: 'var(--community-thyroid-shadow)',
    gradient: 'var(--community-thyroid-gradient)',
  },
  skin: {
    key: 'skin',
    name: 'Skin / Acne',
    hue: 335,
    color: 'var(--community-skin-color)',
    dark: 'var(--community-skin-dark)',
    light: 'var(--community-skin-light)',
    muted: 'var(--community-skin-muted)',
    shadow: 'var(--community-skin-shadow)',
    gradient: 'var(--community-skin-gradient)',
  },
  general: {
    key: 'general',
    name: 'General Health',
    hue: 120,
    color: 'var(--community-general-color)',
    dark: 'var(--community-general-dark)',
    light: 'var(--community-general-light)',
    muted: 'var(--community-general-muted)',
    shadow: 'var(--community-general-shadow)',
    gradient: 'var(--community-general-gradient)',
  },
};

export function resolveCommunityColorKey(value: string | null | undefined): CommunityColorKey {
  const normalized = (value ?? '').trim().toLowerCase();
  if (!normalized) return 'general';
  if (normalized.includes('pcos')) return 'pcos';
  if (normalized.includes('diabetes')) return 'diabetes';
  if (
    normalized.includes('skin')
    || normalized.includes('acne')
    || normalized.includes('pigmentation')
    || normalized.includes('skincare')
    || normalized.includes('dermatologist')
  ) {
    return 'skin';
  }
  if (normalized.includes('mental') || normalized.includes('anxiety') || normalized.includes('sleep')) {
    return 'mental';
  }
  if (normalized.includes('thyroid')) return 'thyroid';
  return 'general';
}
